import api from '../../services/api';
import * as type from '../types';

export default {
    namespaced: true,
    state: {
        upclist: [],
        headers:[
            {
                text: 'Brand',
                value: 'brandName',
                sortable: true,
                width: '200'
            },
            {
                text: 'UPC',
                value: 'itemCrossReference', //need to change, use UPC instead
                sortable: true,
                width: '150'
            },
            {
                text: 'List SKU',
                value: 'listedSKU',
                sortable: true,
                width: '200'
            },
            {
                text: 'ASIN',
                value: 'asin',
                sortable: true,
                width: '100'
            },
            {
                text: 'Item Number',
                value: 'salesCode',
                sortable: true,
                width: '150'
            },
            {
                text: 'Style No',
                value: 'itemNumber',
                sortable: true,
                width: '150'
            },
            {
                text: 'Description',
                value: 'description',
                sortable: true,
                width: '200'
            },
            {
                text: 'Color Code',
                value: 'colorCode',
                sortable: true,
                width: '150'
            },
            {
                text: 'Size Code',
                value: 'sizeCode',
                sortable: true,
                width: '150'
            },
            {
                text: 'Color-Size',
                value: 'variantDescription',
                sortable: true,
                width: '150'
            },
        ]
    },
    getters: {
        getUPCList: state => state.upclist,
        getHeaders: state => state.headers
    },
    mutations: {
        [type.GET_UPCLIST]: (state, payload) => state.upclist = payload
    },
    actions: {
        [type.GET_UPCLIST]: async ({commit}) => {
            commit(`global/${type.SET_LOADING}`, null, { root: true });
            commit(type.GET_UPCLIST, []);
            try {
                let response = await api.get('/get/master-upc-list');
                if(response.status === 200){
                    commit(type.GET_UPCLIST,  response.data);
                    commit(`global/${type.REMOVE_LOADING}`, 'success', { root: true })
                }
            } catch (error) {
                commit(type.GET_UPCLIST, []);
                commit(`global/${type.REMOVE_LOADING}`, 'error', { root: true });
                commit(`global/${type.SET_MESSAGE}`, { type: 'error', message: error.data.err.msg }, { root: true });
            }
        }
    }
}